import { platformApi } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useNicheOccurrence(
  number,
  {
    addresses = false,
    officers = false,
    people = false,
    vehicles = false,
  } = {},
) {
  const queryKey = [
    'occurrences',
    number,
    addresses,
    officers,
    people,
    vehicles,
  ];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const searchParams = new URLSearchParams({
        addresses,
        officers,
        people,
        vehicles,
      });

      try {
        return await platformApi
          .get(`niche/occurrences/${number}`, {
            searchParams,
            signal,
          })
          .json();
      } catch (error) {
        if (error.data?.statusCode === 404) {
          return null;
        } else {
          throw error;
        }
      }
    },
    enabled: !!number,
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
